<template>
  <section class="lead-table">
    <b-table
      :data="statistic"
      :paginated="isPaginated"
      :per-page="perPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
      <b-table-column
        v-if="user.role_id == 1"
        field="agent"
        label="Agent"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.agent }}
      </b-table-column>
      <b-table-column
        field="c_a"
        label="# Assigned"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.c_a }}
      </b-table-column>
      <b-table-column
        field="c_d"
        label="# Deals"
        searchable
        sortable
        v-slot="props"
      >
        <span v-if="props.row.c_d == 0">
          {{ props.row.c_d }}
        </span>
        <span v-else @click="openDialog(props.row.leads)">
          {{ props.row.c_d }}
        </span>
      </b-table-column>
      <b-table-column
        field="c_r"
        label="Closing ratio"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.c_r }}
      </b-table-column>
      <b-table-column
        field="tmp"
        label="Total Monthly Premium"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.tmp }}
      </b-table-column>
      <b-table-column
        field="amp"
        label="Avg Monthly Premium"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.amp }}
      </b-table-column>
      <b-table-column
        field="tot"
        label="Total Online Time"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.tot }}
      </b-table-column>
      <b-table-column
        field="tct"
        label="Total Calls Time"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.tct }}
      </b-table-column>
    </b-table>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="700">
        <v-card>
          <v-card-title class="headline"> List of closed deals </v-card-title>
          <v-card-text>
            <v-data-table
              dense
              :headers="headers"
              :items="leads"
              class="elevation-1"
              @click:row="handleClick"
            ></v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "StatisticTable",
  props: ["user"],
  data() {
    return {
      headers: [
        { text: "Status", value: "s_t" },
        { text: "Fullname", value: "fullname" },
        { text: "Email", value: "email" },
        { text: "Phone", value: "phone" },
      ],
      leads: [],
      dialog: false,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      perPage: 20,
      columns: [
        {
          field: "tmp",
          label: "Total Monthly Premium",
          searchable: true,
          sortable: true,
        },
        {
          field: "amp",
          label: "Avg Monthly Premium",
          searchable: true,
          sortable: true,
        },
      ],
    };
  },
  methods: {
    openDialog(leads) {
      this.dialog = true;
      this.leads = leads;
    },
    handleClick(payload) {
      event.preventDefault();
      if (!payload.busy) {
        this.$router.push({ path: `/lead/${payload.id}` });
      }
    },
  },
  computed: {
    ...mapGetters({
      statistic: "statistic/statistic",
    }),
    prepareColumns() {
      let fieldsArr = this.columns;
      if (this.user.role_id == 2) {
        fieldsArr = this.columns.filter((e) => e.field !== "agent");
      }
      return fieldsArr;
    },
  },
};
</script>